import { layout } from '../../App.routing'

export const tradingUpSegment = [
    layout.component({
        feature: ['trading-up', true],
        type: 'sierra',
        props: {
            hasBackground: true,
            verticalSpacing: 'lg',
            cardOrientation: {
                type: 'Landscape-Portrait',
                maxBreakpoint: 'md',
            },

            cardLayout: [
                'the-west-hero-lgNoBorder-withPublicationDate',
                'large-card-lgNoText',
                'large-card-lgNoText',
            ],
            hideByline: false,
            hasCollectionBorderBottom: true,
            hasHeroBorder: false,
            overrideRestrictedVideoPlayback: true,
            dataDefinitionArgs: {
                type: 'listing',
                topics: ['business/trading-up'],
                includeSubTopics: false,
                paging: {
                    page: 0,
                    pageSize: 3,
                },
            },
            sectionHeader: {
                heading: 'Trading Up',
                headingUrl: '/business/trading-up',
                section: 'business',
            },
        },
    }),
]
